<template>
  <div class="lecture-control">
    <div class="lecture-info mr-2">
      <div class="is-flex is-align-items-center">
        <span class="week-number mr-2">Week {{ lecture.weekNumber }}</span>
        <LectureStatusBadge :status="lecture.status" size="is-small" />
      </div>
      <div class="lecture-date">
        {{ new Date(lecture.lectureDate).toLocaleDateString() }}
      </div>
    </div>

    <b-button
      v-if="lecture.status === 'Created'"
      label="Start"
      type="is-primary is-light"
      outlined
      icon-left="play"
      class="mr-2"
      @click="$emit('start')"
    />

    <b-button
      v-else-if="lecture.status === 'Started'"
      type="is-success is-light"
      outlined
      icon-left="check"
      class="mr-2"
      @click="$emit('complete')"
    >
      Complete
    </b-button>

    <b-button
      v-if="!isPresentationMode"
      :type="showClassRoll ? 'is-success is-light' : 'is-dark is-light'"
      outlined
      icon-left="users"
      class="mr-2"
      @click="$emit('toggle-class-roll')"
    >
      {{ showClassRoll ? "Hide" : "Show" }} Roll
    </b-button>

    <!-- View Tournament Button (when tournament exists) -->
    <b-button
      v-if="!isPresentationMode && currentClass && lecture.tournamentId"
      type="is-warning is-light"
      outlined
      icon-left="chess"
      @click="viewTournament"
    >
      Tournament
    </b-button>

    <!-- Create Tournament Component (when no tournament exists) -->
    <CreateOfflineClassTournament
      v-if="!isPresentationMode && currentClass && !lecture.tournamentId"
      :current-class="currentClass"
      :lecture="lecture"
      button-text="Tournament"
      button-type="is-primary is-light"
      button-icon="chess"
      @tournament-created="onTournamentCreated"
      @tournament-error="onTournamentError"
    />
  </div>
</template>

<script>
import LectureStatusBadge from "./atoms/LectureStatusBadge.vue";
import CreateOfflineClassTournament from "@/components/shared/CreateOfflineClassTournament.vue";
import { mapGetters } from "vuex";

export default {
  name: "LectureControl",

  components: {
    LectureStatusBadge,
    CreateOfflineClassTournament,
  },

  props: {
    lecture: {
      type: Object,
      required: true,
    },
    showClassRoll: {
      type: Boolean,
      default: true,
    },
    isPresentationMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      currentClass: "getCurrentClass",
    }),
  },

  methods: {
    /**
     * Navigate to existing tournament
     */
    viewTournament() {
      this.$router.push(
        `/teacher/class-tournaments/${this.lecture.tournamentId}`
      );
    },

    /**
     * Handle successful tournament creation
     */
    onTournamentCreated(tournamentId) {
      console.log("Lecture Tournament created successfully:", tournamentId);
    },

    /**
     * Handle tournament creation error
     */
    onTournamentError(error) {
      console.error("Lecture Tournament creation failed:", error);
    },
  },
};
</script>

<style scoped>
.lecture-control {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem;
  background: white;
  border-radius: 6px;
  border: 1px solid #eee;
  margin-left: 1rem;
}

.lecture-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.week-number {
  font-weight: 600;
}

.lecture-date {
  color: #666;
  font-size: 0.9rem;
}
</style>
